module.exports = __webpack_public_path__ + "img/Swedbank_logo.svg.253fc816.png";